<template>
  <v-container>
    <v-row>
      <v-col>
        <v-select
          :items="sites"
          label="工地"
          v-model="queryData.site"
        ></v-select>
        <v-select
          :items="problemTypes"
          label="問題類別"
          v-model="queryData.problemType"
        ></v-select>
        <v-select
          :items="status"
          label="狀態"
          v-model="queryData.completed"
        ></v-select>
        <v-btn
          depressed
          block
          @click="searchRepair"
          color="blue-grey white--text"
          >搜尋</v-btn
        >
      </v-col>
    </v-row>

    <v-row>
      <v-col v-if="searchRepairs.length === 0" class="d-flex justify-center">
        查無資料，請選擇查詢工地
      </v-col>
      <v-col
        v-else
        v-for="(repair, index) in searchRepairs"
        :key="index"
        cols="12"
      >
        <card
          :id="repair.id"
          :site="repair.site"
          :completed="repair.completed"
          :description="repair.description"
          :problemType="repair.problemType"
          :created_at="repair.created_at"
          :repairItems="repair.repairItems"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
// @ is an alias to /src
import Card from "@/components/Card";
import { repairsCollection } from "@/db";

export default {
  name: "Search",
  data: () => ({
    status: ["", "未完成", "完成"],
    sites: [
      "樂嵩豐",
      "耀嵩豐",
      "悅嵩豐",
      "松丰",
      "文川",
      "淨美墅",
      "世璽",
      "帝門",
      "自由鑫貴",
      "綠園市2",
      "綠園市1",
      "品美術",
      "觀美術",
      "大社官邸",
      "嵩豐臻寶",
      "狀元邸",
      "嵩之園",
      "千禧園",
      "三荷園",
      "東方伯爵"
    ],
    problemTypes: [
      "",
      "水電",
      "防水",
      "衛浴設備",
      "弱電",
      "磁磚",
      "廚具",
      "油漆",
      "木作",
      "其他"
    ],
    searchRepairs: [],
    queryData: {
      site: "",
      problemType: "",
      completed: ""
    }
  }),
  components: { card: Card },
  methods: {
    searchRepair() {
      this.clearRepairs();
      var query = repairsCollection;
      query = query.where("site", "==", this.queryData.site);
      if (this.queryData.problemType !== "") {
        query = query.where("problemType", "==", this.queryData.problemType);
      }
      if (this.queryData.completed !== "") {
        const status = this.queryData.completed === "未完成" ? false : true;
        query = query.where("completed", "==", status);
      }
      query
        .orderBy("created_at")
        // .limit(20)
        .get()
        .then(querySnapshot => {
          querySnapshot.docs.forEach(element => {
            const repairData = {
              id: element.id,
              site: element.data().site,
              completed: element.data().completed,
              repairItems: element.data().repair_items.length,
              problemType: element.data().problemType,
              description: element.data().description,
              created_at: element
                .data()
                .created_at.toDate()
                .toISOString()
                .slice(0, 10)
            };
            this.searchRepairs.push(repairData);
          });
        });
    },
    clearRepairs() {
      this.searchRepairs = [];
    }
  }
};
</script>
